export enum SortOptionType {
  CreatedDate = 'CREATED_DATE',
  ItemSavedAt = 'ITEM_SAVED_AT',
  Name = 'NAME',
  EarnRate = 'EARN_RATE',
  MemberSalePrice = 'MEMBER_SALE_PRICE',
}
